import clsx from "clsx";
import React from "react";
import { Grid2Props } from "@mui/material";

import { LibraryPrivacy } from "@growth-machine-llc/stridist-api-client";
import {
  JourneyAnchors,
  AllOption,
  LibraryPrivacyFilter,
} from "../../constants";
import { CoachLibraryHeader } from "../library/CoachLibraryHeader";
import { useCurrentUser } from "../../hooks/useCurrentUser";

export interface CoachLibraryHeaderFiltersBaseProps extends Grid2Props {
  query: string;
  defaultQuery?: string;
  onChangeQuery?: (query: string) => void;
  privacy?: LibraryPrivacyFilter;
  onChangePrivacy?: (privacy: LibraryPrivacyFilter) => void;
  disabledResetButton?: boolean;
  onResetFilters?: () => void;
  showResetButton?: boolean;
}

const ExercisePrivacyOptions = (isTeamAccount: boolean) => [
  {
    value: AllOption,
    tooltip: "All exercises",
    label: "All",
  },
  {
    value: LibraryPrivacy.PRIVATE,
    tooltip: "Private exercises uploaded by me",
    label: "Private",
  },
  ...(isTeamAccount
    ? [
        {
          value: LibraryPrivacy.TEAM,
          tooltip: "Team exercises shared with all coaches",
          label: "Team",
        },
      ]
    : []),
  {
    value: LibraryPrivacy.PUBLIC,
    tooltip: "Public exercises uploaded by Stridist",
    label: "Public",
  },
];

export interface CoachExerciseLibraryHeaderFiltersProps
  extends CoachLibraryHeaderFiltersBaseProps {
  isTagsRoute?: boolean;
  showFilterByType?: boolean;
}

export function CoachExerciseLibraryHeaderFilters(
  props: CoachExerciseLibraryHeaderFiltersProps,
) {
  const {
    className,
    query,
    onChangeQuery,
    privacy,
    onChangePrivacy,
    isTagsRoute = false,
    disabledResetButton,
    onResetFilters,
    showResetButton,
    showFilterByType,
    defaultQuery,
  } = props;

  const { isTeamAccount } = useCurrentUser();

  const showResetAndSearchInOneRow = showResetButton && !showFilterByType;
  const handleChangePrivacy = React.useCallback(
    (privacy: LibraryPrivacyFilter) => {
      if (onChangePrivacy) {
        onChangePrivacy(privacy);
      }
    },
    [onChangePrivacy],
  );

  return (
    <CoachLibraryHeader<LibraryPrivacyFilter>
      className={className}
      query={query}
      defaultQuery={defaultQuery || ""}
      searchPlaceholder={`Search by ${isTagsRoute ? "tags" : "exercises"}`}
      onChangeQuery={onChangeQuery}
      showActions={!isTagsRoute}
      inlineActions={showResetAndSearchInOneRow}
      toggleOptions={
        showFilterByType ? ExercisePrivacyOptions(isTeamAccount) : undefined
      }
      toggleValue={privacy}
      onChangeToggle={handleChangePrivacy}
      toggleClassName={clsx(JourneyAnchors.EXERCISE_LIBRARY_PRIVACY_FILTER)}
      showResetButton={showResetButton}
      disabledResetButton={disabledResetButton}
      onResetFilters={onResetFilters}
      resetButtonClassName={clsx(JourneyAnchors.EXERCISE_LIBRARY_RESET_FILTERS)}
    />
  );
}
